const errorGroupFactor = 1000000;

export const pleaseUpdate =
  'We are investigating. In the meantime, make sure you are using the latest version of our software then try again.';

export enum ErrorGroup {
  Backend = 0 * errorGroupFactor,
  BackendClient = 1 * errorGroupFactor,
  ClientCore = 2 * errorGroupFactor,
  LibVaultCrypto = 3 * errorGroupFactor,
  ClientNodeBridge = 4 * errorGroupFactor,
  ClientWebSdk = 5 * errorGroupFactor,
  Heymerge = 6 * errorGroupFactor,
}

export class DomainError extends Error {
  constructor(
    readonly code: number,
    readonly short: string,
    readonly userTitle: string,
    readonly userDetail: string,
  ) {
    super(short);
    this.name = 'DomainError';
    Object.setPrototypeOf(this, new.target.prototype);
  }

  private codeGroup(): number {
    return this.code - (this.code % errorGroupFactor);
  }

  isClientError(): boolean {
    return this.codeGroup() === ErrorGroup.ClientCore;
  }

  isBackendError(): boolean {
    return this.codeGroup() === ErrorGroup.Backend;
  }

  isLibVaultCryptoError(): boolean {
    return this.codeGroup() === ErrorGroup.LibVaultCrypto;
  }

  isClientWebSdkError(): boolean {
    return this.codeGroup() === ErrorGroup.ClientWebSdk;
  }

  isHeymergeError(): boolean {
    return this.codeGroup() === ErrorGroup.Heymerge;
  }
}
